import { memo, useCallback, useState } from 'react'
import Button from '../../components/Button'
import { clearOrderInProgress } from '../../actions/order'
import { useDispatch, useSelector } from 'react-redux'
import { setRoute } from '../../VNRoutes/ActionCreators'
import { hasCartItems2 } from '../../selectors/cart'
import useSpinner from '../../context/hooks/useSpinner'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { setShouldIncrementOrderNumber } from '../../VNOrders/ActionCreators'
import { ReactComponent as MobileShoppingCartOutlinedIcon } from '../../assets/icons/mobileCart.svg'
import { ReactComponent as ShoppingCartOutlinedIcon } from '../../assets/icons/Cart.svg'
import { clearCart } from '../../actions/cart'
import { getDeviceMode } from '../../VNMode/Selectors'
import { resetCFDrequest } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { MODES } from '../../VNMode/Reducer'
import useGetIsMobileScreen from '../../hooks/useGetIsMobileScreen'
import { ToastManager } from '../../utils/toastManager'
import { APPLICATION_STRINGS } from '../../strings'

const VNAllOrdersButton = ({ className }) => {
  const dispatch = useDispatch()

  const [showConfirmAbandonCartModal, setShowConfirmAbandonCartModal] = useState(false)
  const isMobileViewPort = useGetIsMobileScreen()
  const cfdMode = useSelector(getDeviceMode)
  const hasCartItems = useSelector(hasCartItems2)
  const { startSpinner } = useSpinner()

  const handleallOrdersButtonClick = useCallback(() => {
    if (hasCartItems) {
      setShowConfirmAbandonCartModal(true)
      return
    }

    dispatch(clearOrderInProgress())
    startSpinner()
    dispatch(setRoute('/orders'))
  }, [dispatch, hasCartItems, startSpinner])

  const shoppingCartIcon = isMobileViewPort ? <MobileShoppingCartOutlinedIcon /> : <ShoppingCartOutlinedIcon />
  const abandonCartMessage = isMobileViewPort
    ? 'Items in cart will be removed upon syncing or navigating away from the menu. Do you wish to continue?'
    : 'Items in cart will be removed upon\n syncing or navigating away from the\n menu. Do you wish to continue?'

  const confirmAbandonCartElement = (
    <ConfirmModalV2
      onButtonOneClick={() => {
        setShowConfirmAbandonCartModal(false)
      }}
      onButtonTwoClick={() => {
        dispatch(setShouldIncrementOrderNumber())
        setShowConfirmAbandonCartModal(false)
        dispatch(clearCart())
        dispatch(clearOrderInProgress())
        if (cfdMode === MODES.POS) {
          resetCFDrequest()
        }
        ToastManager.success(APPLICATION_STRINGS.CART_CLEARED)
        startSpinner()
        dispatch(setRoute('/orders'))
      }}
      headerText={shoppingCartIcon}
      subtext={abandonCartMessage}
      isKiosk={false}
      buttonOneText={'Cancel'}
      buttonTwoText={'Abandon Cart'}
    />
  )

  return (
    <>
      <Button useMui className={className} onClick={handleallOrdersButtonClick}>
        All Orders
      </Button>
      {showConfirmAbandonCartModal && confirmAbandonCartElement}
    </>
  )
}

export default memo(VNAllOrdersButton)
